class spaceVertexMapping {
    store;
    spaceId;
    vertexId;
    constructor(store, spaceId, vertexId) {
        this.store = store;
        this.spaceId = spaceId;
        this.vertexId = vertexId;
    }
    static fromJSON(store, json) {
        let { spaceId, vertexId } = json;
        return new spaceVertexMapping(store, spaceId, vertexId);
    }
  }
  export default spaceVertexMapping;
